import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

import { TColor } from 'app/services/api5-service/api.interface';
import { TabParams } from 'app/services/tab/model';

import { ThemePalette } from '@ispui/link';

import {
  IImgUi,
  ILinkClickEvent,
} from 'common/dynamic-form/dynamic-form.interface';
import { convertStringToParamsWithDecode } from 'utils/convert-string-to-params';

import { LinkUi } from './model/link-ui.interface';

@Component({
  selector: 'isp-link',
  templateUrl: './link.component.html',
  styleUrls: ['./scss/link.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkComponent implements LinkUi {
  @Input() caption: string;

  @Input() target: LinkUi['target'];

  @Input() internal: boolean;

  @Input() newTab: boolean;

  @Input() sameTab: boolean;

  @Input() href: string;

  @Input() img?: IImgUi;

  @Input() imgPlace?: 'left' | 'right' = 'left';

  @Input() color?: TColor;

  @Output() readonly clickEvent = new EventEmitter<ILinkClickEvent>();

  private get fixedHref(): string {
    return this.href.includes('func=') ? this.href : `func=${this.href}`;
  }

  get linkHref(): string {
    if (!this.internal) {
      return this.href;
    } else {
      // for internal links BE sends only query params
      // so use angular internal routing for tabs opening
      return `#/${this.fixedHref}`;
    }
  }

  get linkColor(): ThemePalette | undefined {
    switch (this.color) {
      case 'grey':
        return 'additional';
      case 'red':
        return 'fail';
      case 'green':
        return 'success';
      // no color for yellow, cyan and main
      case 'cyan':
      case 'yellow':
      case 'main':
        return undefined;
      case 'blue':
      default:
        return 'primary';
    }
  }

  handleClick(event: KeyboardEvent | MouseEvent): void {
    if (!this.internal) {
      return;
    }

    event.preventDefault();

    let target: ILinkClickEvent['target'] = 'child';

    if (this.newTab) {
      target = 'new';
    } else if (this.sameTab) {
      target = 'same';
    }

    const tabParams = convertStringToParamsWithDecode(
      this.fixedHref,
    ) as TabParams;

    this.clickEvent.emit({
      target,
      tabParams,
    });
  }
}
